/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfDateTime } from '../models/custom-result-of-date-time';
import { CustomResultOfGetIsAuthenticatedByIdDto } from '../models/custom-result-of-get-is-authenticated-by-id-dto';
import { CustomResultOfListOfDownloadAllOrganizationDocumentsDto } from '../models/custom-result-of-list-of-download-all-organization-documents-dto';
import { CustomResultOfListOfGetCurrentResellerOrganizationListDto } from '../models/custom-result-of-list-of-get-current-reseller-organization-list-dto';
import { CustomResultOfListOfGetOrganizationChildrenAndItselfListDto } from '../models/custom-result-of-list-of-get-organization-children-and-itself-list-dto';
import { CustomResultOfListOfGetOrganizationDescendantAndItselfListDto } from '../models/custom-result-of-list-of-get-organization-descendant-and-itself-list-dto';
import { CustomResultOfListOfGetOrganizationDescendantListDto } from '../models/custom-result-of-list-of-get-organization-descendant-list-dto';
import { CustomResultOfListOfOrganizationsListByGroupPriceCategoryIdDto } from '../models/custom-result-of-list-of-organizations-list-by-group-price-category-id-dto';
import { CustomResultOfLong } from '../models/custom-result-of-long';
import { CustomResultOfNullableBoolean } from '../models/custom-result-of-nullable-boolean';
import { CustomResultOfOrganizationDto } from '../models/custom-result-of-organization-dto';
import { CustomResultOfPaginatedListOfOrganizationWithPaginationDto } from '../models/custom-result-of-paginated-list-of-organization-with-pagination-dto';
import { CustomResultOfPaginatedListOfResellerOrganizationWithPaginationDto } from '../models/custom-result-of-paginated-list-of-reseller-organization-with-pagination-dto';
import { organizationsChangeOrganizationIsActive } from '../fn/organizations/organizations-change-organization-is-active';
import { OrganizationsChangeOrganizationIsActive$Params } from '../fn/organizations/organizations-change-organization-is-active';
import { organizationsCreateGet } from '../fn/organizations/organizations-create-get';
import { OrganizationsCreateGet$Params } from '../fn/organizations/organizations-create-get';
import { organizationsCreatePost } from '../fn/organizations/organizations-create-post';
import { OrganizationsCreatePost$Params } from '../fn/organizations/organizations-create-post';
import { organizationsDelete } from '../fn/organizations/organizations-delete';
import { OrganizationsDelete$Params } from '../fn/organizations/organizations-delete';
import { organizationsDeleteOrganizationWithDescendant } from '../fn/organizations/organizations-delete-organization-with-descendant';
import { OrganizationsDeleteOrganizationWithDescendant$Params } from '../fn/organizations/organizations-delete-organization-with-descendant';
import { organizationsDownloadAllOrganizationDocuments } from '../fn/organizations/organizations-download-all-organization-documents';
import { OrganizationsDownloadAllOrganizationDocuments$Params } from '../fn/organizations/organizations-download-all-organization-documents';
import { organizationsGetCurrentOrganizationExpireDateForAdmin } from '../fn/organizations/organizations-get-current-organization-expire-date-for-admin';
import { OrganizationsGetCurrentOrganizationExpireDateForAdmin$Params } from '../fn/organizations/organizations-get-current-organization-expire-date-for-admin';
import { organizationsGetCurrentResellerOrganizationList } from '../fn/organizations/organizations-get-current-reseller-organization-list';
import { OrganizationsGetCurrentResellerOrganizationList$Params } from '../fn/organizations/organizations-get-current-reseller-organization-list';
import { organizationsGetIsAuthenticatedById } from '../fn/organizations/organizations-get-is-authenticated-by-id';
import { OrganizationsGetIsAuthenticatedById$Params } from '../fn/organizations/organizations-get-is-authenticated-by-id';
import { organizationsGetOrganizationChildrenAndItselfList } from '../fn/organizations/organizations-get-organization-children-and-itself-list';
import { OrganizationsGetOrganizationChildrenAndItselfList$Params } from '../fn/organizations/organizations-get-organization-children-and-itself-list';
import { organizationsGetOrganizationCredit } from '../fn/organizations/organizations-get-organization-credit';
import { OrganizationsGetOrganizationCredit$Params } from '../fn/organizations/organizations-get-organization-credit';
import { organizationsGetOrganizationCreditForAdmin } from '../fn/organizations/organizations-get-organization-credit-for-admin';
import { OrganizationsGetOrganizationCreditForAdmin$Params } from '../fn/organizations/organizations-get-organization-credit-for-admin';
import { organizationsGetOrganizationCreditForDashboard } from '../fn/organizations/organizations-get-organization-credit-for-dashboard';
import { OrganizationsGetOrganizationCreditForDashboard$Params } from '../fn/organizations/organizations-get-organization-credit-for-dashboard';
import { organizationsGetOrganizationDescendantAndItselfList } from '../fn/organizations/organizations-get-organization-descendant-and-itself-list';
import { OrganizationsGetOrganizationDescendantAndItselfList$Params } from '../fn/organizations/organizations-get-organization-descendant-and-itself-list';
import { organizationsGetOrganizationDescendantList } from '../fn/organizations/organizations-get-organization-descendant-list';
import { OrganizationsGetOrganizationDescendantList$Params } from '../fn/organizations/organizations-get-organization-descendant-list';
import { organizationsGetOrganizationForCreateUser } from '../fn/organizations/organizations-get-organization-for-create-user';
import { OrganizationsGetOrganizationForCreateUser$Params } from '../fn/organizations/organizations-get-organization-for-create-user';
import { organizationsGetOrganizationsAudit } from '../fn/organizations/organizations-get-organizations-audit';
import { OrganizationsGetOrganizationsAudit$Params } from '../fn/organizations/organizations-get-organizations-audit';
import { organizationsGetOrganizationsListByGroupPriceCategoryId } from '../fn/organizations/organizations-get-organizations-list-by-group-price-category-id';
import { OrganizationsGetOrganizationsListByGroupPriceCategoryId$Params } from '../fn/organizations/organizations-get-organizations-list-by-group-price-category-id';
import { organizationsGetOrganizationsWithPagination } from '../fn/organizations/organizations-get-organizations-with-pagination';
import { OrganizationsGetOrganizationsWithPagination$Params } from '../fn/organizations/organizations-get-organizations-with-pagination';
import { organizationsGetResellerOrganizationWithPagination } from '../fn/organizations/organizations-get-reseller-organization-with-pagination';
import { OrganizationsGetResellerOrganizationWithPagination$Params } from '../fn/organizations/organizations-get-reseller-organization-with-pagination';
import { organizationsIsExistsOrganization } from '../fn/organizations/organizations-is-exists-organization';
import { OrganizationsIsExistsOrganization$Params } from '../fn/organizations/organizations-is-exists-organization';
import { organizationsOrganizationDocumentLink } from '../fn/organizations/organizations-organization-document-link';
import { OrganizationsOrganizationDocumentLink$Params } from '../fn/organizations/organizations-organization-document-link';
import { organizationsUpdateGet } from '../fn/organizations/organizations-update-get';
import { OrganizationsUpdateGet$Params } from '../fn/organizations/organizations-update-get';
import { organizationsUpdateOrganizationDocumentsStatus } from '../fn/organizations/organizations-update-organization-documents-status';
import { OrganizationsUpdateOrganizationDocumentsStatus$Params } from '../fn/organizations/organizations-update-organization-documents-status';
import { organizationsUpdateOrganizationGroupPriceCategory } from '../fn/organizations/organizations-update-organization-group-price-category';
import { OrganizationsUpdateOrganizationGroupPriceCategory$Params } from '../fn/organizations/organizations-update-organization-group-price-category';
import { organizationsUpdateOrganizationIsAuthenticated } from '../fn/organizations/organizations-update-organization-is-authenticated';
import { OrganizationsUpdateOrganizationIsAuthenticated$Params } from '../fn/organizations/organizations-update-organization-is-authenticated';
import { organizationsUpdatePut } from '../fn/organizations/organizations-update-put';
import { OrganizationsUpdatePut$Params } from '../fn/organizations/organizations-update-put';
import { organizationsUploadOrganizationDocuments } from '../fn/organizations/organizations-upload-organization-documents';
import { OrganizationsUploadOrganizationDocuments$Params } from '../fn/organizations/organizations-upload-organization-documents';

@Injectable({ providedIn: 'root' })
export class OrganizationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationsGetOrganizationsAudit()` */
  static readonly OrganizationsGetOrganizationsAuditPath = '/Organizations/GetOrganizationsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsGetOrganizationsAudit$Response(params: OrganizationsGetOrganizationsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return organizationsGetOrganizationsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsGetOrganizationsAudit(params: OrganizationsGetOrganizationsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.organizationsGetOrganizationsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `organizationsGetResellerOrganizationWithPagination()` */
  static readonly OrganizationsGetResellerOrganizationWithPaginationPath = '/Organizations/GetResellerOrganizationWithPagination';

  /**
   * دریافت لیست سازمان های فروشنده فعلی با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetResellerOrganizationWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsGetResellerOrganizationWithPagination$Response(params: OrganizationsGetResellerOrganizationWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfResellerOrganizationWithPaginationDto>> {
    return organizationsGetResellerOrganizationWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست سازمان های فروشنده فعلی با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetResellerOrganizationWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsGetResellerOrganizationWithPagination(params: OrganizationsGetResellerOrganizationWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfResellerOrganizationWithPaginationDto> {
    return this.organizationsGetResellerOrganizationWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfResellerOrganizationWithPaginationDto>): CustomResultOfPaginatedListOfResellerOrganizationWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationsWithPagination()` */
  static readonly OrganizationsGetOrganizationsWithPaginationPath = '/Organizations/GetOrganizationsWithPagination';

  /**
   * For each user get Organizations with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsGetOrganizationsWithPagination$Response(params: OrganizationsGetOrganizationsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfOrganizationWithPaginationDto>> {
    return organizationsGetOrganizationsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get Organizations with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsGetOrganizationsWithPagination(params: OrganizationsGetOrganizationsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfOrganizationWithPaginationDto> {
    return this.organizationsGetOrganizationsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfOrganizationWithPaginationDto>): CustomResultOfPaginatedListOfOrganizationWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `organizationsGetIsAuthenticatedById()` */
  static readonly OrganizationsGetIsAuthenticatedByIdPath = '/Organizations/GetIsAuthenticatedById';

  /**
   * Get Organization by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetIsAuthenticatedById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetIsAuthenticatedById$Response(params?: OrganizationsGetIsAuthenticatedById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetIsAuthenticatedByIdDto>> {
    return organizationsGetIsAuthenticatedById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Organization by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetIsAuthenticatedById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetIsAuthenticatedById(params?: OrganizationsGetIsAuthenticatedById$Params, context?: HttpContext): Observable<CustomResultOfGetIsAuthenticatedByIdDto> {
    return this.organizationsGetIsAuthenticatedById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetIsAuthenticatedByIdDto>): CustomResultOfGetIsAuthenticatedByIdDto => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationChildrenAndItselfList()` */
  static readonly OrganizationsGetOrganizationChildrenAndItselfListPath = '/Organizations/GetOrganizationChildrenAndItselfList';

  /**
   * Get list of current Organization's Children and Itself.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationChildrenAndItselfList()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationChildrenAndItselfList$Response(params?: OrganizationsGetOrganizationChildrenAndItselfList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOrganizationChildrenAndItselfListDto>> {
    return organizationsGetOrganizationChildrenAndItselfList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of current Organization's Children and Itself.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationChildrenAndItselfList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationChildrenAndItselfList(params?: OrganizationsGetOrganizationChildrenAndItselfList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOrganizationChildrenAndItselfListDto> {
    return this.organizationsGetOrganizationChildrenAndItselfList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOrganizationChildrenAndItselfListDto>): CustomResultOfListOfGetOrganizationChildrenAndItselfListDto => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationDescendantList()` */
  static readonly OrganizationsGetOrganizationDescendantListPath = '/Organizations/GetOrganizationDescendantList';

  /**
   * Get list of current Organization's Descendant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationDescendantList()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationDescendantList$Response(params?: OrganizationsGetOrganizationDescendantList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOrganizationDescendantListDto>> {
    return organizationsGetOrganizationDescendantList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of current Organization's Descendant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationDescendantList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationDescendantList(params?: OrganizationsGetOrganizationDescendantList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOrganizationDescendantListDto> {
    return this.organizationsGetOrganizationDescendantList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOrganizationDescendantListDto>): CustomResultOfListOfGetOrganizationDescendantListDto => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationDescendantAndItselfList()` */
  static readonly OrganizationsGetOrganizationDescendantAndItselfListPath = '/Organizations/GetOrganizationDescendantAndItselfList';

  /**
   * Get list of current Organization's Descendant and Itself.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationDescendantAndItselfList()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationDescendantAndItselfList$Response(params?: OrganizationsGetOrganizationDescendantAndItselfList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOrganizationDescendantAndItselfListDto>> {
    return organizationsGetOrganizationDescendantAndItselfList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of current Organization's Descendant and Itself.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationDescendantAndItselfList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationDescendantAndItselfList(params?: OrganizationsGetOrganizationDescendantAndItselfList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOrganizationDescendantAndItselfListDto> {
    return this.organizationsGetOrganizationDescendantAndItselfList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOrganizationDescendantAndItselfListDto>): CustomResultOfListOfGetOrganizationDescendantAndItselfListDto => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationForCreateUser()` */
  static readonly OrganizationsGetOrganizationForCreateUserPath = '/Organizations/GetOrganizationForCreateUser';

  /**
   * Get Organization For Create User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationForCreateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationForCreateUser$Response(params?: OrganizationsGetOrganizationForCreateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOrganizationDescendantAndItselfListDto>> {
    return organizationsGetOrganizationForCreateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Organization For Create User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationForCreateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationForCreateUser(params?: OrganizationsGetOrganizationForCreateUser$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOrganizationDescendantAndItselfListDto> {
    return this.organizationsGetOrganizationForCreateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOrganizationDescendantAndItselfListDto>): CustomResultOfListOfGetOrganizationDescendantAndItselfListDto => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationCredit()` */
  static readonly OrganizationsGetOrganizationCreditPath = '/Organizations/GetOrganizationCredit';

  /**
   * Get Organization Credit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationCredit()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationCredit$Response(params?: OrganizationsGetOrganizationCredit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfLong>> {
    return organizationsGetOrganizationCredit(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Organization Credit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationCredit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationCredit(params?: OrganizationsGetOrganizationCredit$Params, context?: HttpContext): Observable<CustomResultOfLong> {
    return this.organizationsGetOrganizationCredit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfLong>): CustomResultOfLong => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationCreditForDashboard()` */
  static readonly OrganizationsGetOrganizationCreditForDashboardPath = '/Organizations/GetOrganizationCreditForDashboard';

  /**
   * دریافت میزان موجودی سازمان برای نمایش در داشبورد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationCreditForDashboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationCreditForDashboard$Response(params?: OrganizationsGetOrganizationCreditForDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfLong>> {
    return organizationsGetOrganizationCreditForDashboard(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت میزان موجودی سازمان برای نمایش در داشبورد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationCreditForDashboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationCreditForDashboard(params?: OrganizationsGetOrganizationCreditForDashboard$Params, context?: HttpContext): Observable<CustomResultOfLong> {
    return this.organizationsGetOrganizationCreditForDashboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfLong>): CustomResultOfLong => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationCreditForAdmin()` */
  static readonly OrganizationsGetOrganizationCreditForAdminPath = '/Organizations/GetOrganizationCreditForAdmin';

  /**
   * دریافت میزان موجودی سازمان برای نمایش در پلن ها ویژه ادمین سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationCreditForAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationCreditForAdmin$Response(params?: OrganizationsGetOrganizationCreditForAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfLong>> {
    return organizationsGetOrganizationCreditForAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت میزان موجودی سازمان برای نمایش در پلن ها ویژه ادمین سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationCreditForAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationCreditForAdmin(params?: OrganizationsGetOrganizationCreditForAdmin$Params, context?: HttpContext): Observable<CustomResultOfLong> {
    return this.organizationsGetOrganizationCreditForAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfLong>): CustomResultOfLong => r.body)
    );
  }

  /** Path part for operation `organizationsCreateGet()` */
  static readonly OrganizationsCreateGetPath = '/Organizations/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsCreateGet$Response(params?: OrganizationsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return organizationsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsCreateGet(params?: OrganizationsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.organizationsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `organizationsCreatePost()` */
  static readonly OrganizationsCreatePostPath = '/Organizations/Create';

  /**
   * Create Organization - Use ONLY for.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreatePost$Response(params: OrganizationsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Organization - Use ONLY for.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreatePost(params: OrganizationsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateGet()` */
  static readonly OrganizationsUpdateGetPath = '/Organizations/Update';

  /**
   * Get Organization by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsUpdateGet$Response(params?: OrganizationsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfOrganizationDto>> {
    return organizationsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Organization by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsUpdateGet(params?: OrganizationsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfOrganizationDto> {
    return this.organizationsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfOrganizationDto>): CustomResultOfOrganizationDto => r.body)
    );
  }

  /** Path part for operation `organizationsUpdatePut()` */
  static readonly OrganizationsUpdatePutPath = '/Organizations/Update';

  /**
   * Update Organization - Use for SuperAdmin and (Parents and Current) Admins.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdatePut$Response(params: OrganizationsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Organization - Use for SuperAdmin and (Parents and Current) Admins.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdatePut(params: OrganizationsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsDelete()` */
  static readonly OrganizationsDeletePath = '/Organizations/{id}';

  /**
   * Delete Organization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDelete$Response(params: OrganizationsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Organization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDelete(params: OrganizationsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsDeleteOrganizationWithDescendant()` */
  static readonly OrganizationsDeleteOrganizationWithDescendantPath = '/Organizations/DeleteOrganizationWithDescendant';

  /**
   * Delete Organization With Descendant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDeleteOrganizationWithDescendant()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteOrganizationWithDescendant$Response(params?: OrganizationsDeleteOrganizationWithDescendant$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsDeleteOrganizationWithDescendant(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Organization With Descendant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDeleteOrganizationWithDescendant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteOrganizationWithDescendant(params?: OrganizationsDeleteOrganizationWithDescendant$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsDeleteOrganizationWithDescendant$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsUploadOrganizationDocuments()` */
  static readonly OrganizationsUploadOrganizationDocumentsPath = '/Organizations/UploadOrganizationDocuments';

  /**
   * Upload Organization Documents - Use for AdminUser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUploadOrganizationDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUploadOrganizationDocuments$Response(params: OrganizationsUploadOrganizationDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsUploadOrganizationDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload Organization Documents - Use for AdminUser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUploadOrganizationDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUploadOrganizationDocuments(params: OrganizationsUploadOrganizationDocuments$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsUploadOrganizationDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateOrganizationDocumentsStatus()` */
  static readonly OrganizationsUpdateOrganizationDocumentsStatusPath = '/Organizations/UpdateOrganizationDocumentsStatus';

  /**
   * Update Organization Documents Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateOrganizationDocumentsStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateOrganizationDocumentsStatus$Response(params: OrganizationsUpdateOrganizationDocumentsStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsUpdateOrganizationDocumentsStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Organization Documents Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateOrganizationDocumentsStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateOrganizationDocumentsStatus(params: OrganizationsUpdateOrganizationDocumentsStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsUpdateOrganizationDocumentsStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsDownloadAllOrganizationDocuments()` */
  static readonly OrganizationsDownloadAllOrganizationDocumentsPath = '/Organizations/DownloadAllOrganizationDocuments';

  /**
   * Download All Organization Documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDownloadAllOrganizationDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDownloadAllOrganizationDocuments$Response(params?: OrganizationsDownloadAllOrganizationDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfDownloadAllOrganizationDocumentsDto>> {
    return organizationsDownloadAllOrganizationDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Download All Organization Documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDownloadAllOrganizationDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDownloadAllOrganizationDocuments(params?: OrganizationsDownloadAllOrganizationDocuments$Params, context?: HttpContext): Observable<CustomResultOfListOfDownloadAllOrganizationDocumentsDto> {
    return this.organizationsDownloadAllOrganizationDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfDownloadAllOrganizationDocumentsDto>): CustomResultOfListOfDownloadAllOrganizationDocumentsDto => r.body)
    );
  }

  /** Path part for operation `organizationsOrganizationDocumentLink()` */
  static readonly OrganizationsOrganizationDocumentLinkPath = '/Organizations/OrganizationDocumentLink';

  /**
   * Download Organization Document Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsOrganizationDocumentLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOrganizationDocumentLink$Response(params?: OrganizationsOrganizationDocumentLink$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return organizationsOrganizationDocumentLink(this.http, this.rootUrl, params, context);
  }

  /**
   * Download Organization Document Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsOrganizationDocumentLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOrganizationDocumentLink(params?: OrganizationsOrganizationDocumentLink$Params, context?: HttpContext): Observable<Blob> {
    return this.organizationsOrganizationDocumentLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateOrganizationIsAuthenticated()` */
  static readonly OrganizationsUpdateOrganizationIsAuthenticatedPath = '/Organizations/UpdateOrganizationIsAuthenticated';

  /**
   * Update field IsAuthenticated of Organization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateOrganizationIsAuthenticated()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateOrganizationIsAuthenticated$Response(params: OrganizationsUpdateOrganizationIsAuthenticated$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsUpdateOrganizationIsAuthenticated(this.http, this.rootUrl, params, context);
  }

  /**
   * Update field IsAuthenticated of Organization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateOrganizationIsAuthenticated$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateOrganizationIsAuthenticated(params: OrganizationsUpdateOrganizationIsAuthenticated$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsUpdateOrganizationIsAuthenticated$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsChangeOrganizationIsActive()` */
  static readonly OrganizationsChangeOrganizationIsActivePath = '/Organizations/ChangeOrganizationIsActive';

  /**
   * Update cache for change isActive organization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsChangeOrganizationIsActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsChangeOrganizationIsActive$Response(params?: OrganizationsChangeOrganizationIsActive$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsChangeOrganizationIsActive(this.http, this.rootUrl, params, context);
  }

  /**
   * Update cache for change isActive organization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsChangeOrganizationIsActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsChangeOrganizationIsActive(params?: OrganizationsChangeOrganizationIsActive$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsChangeOrganizationIsActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsGetOrganizationsListByGroupPriceCategoryId()` */
  static readonly OrganizationsGetOrganizationsListByGroupPriceCategoryIdPath = '/Organizations/GetOrganizationsListByGroupPriceCategoryId';

  /**
   * Get Organizations List By Group Price Category Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetOrganizationsListByGroupPriceCategoryId()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationsListByGroupPriceCategoryId$Response(params?: OrganizationsGetOrganizationsListByGroupPriceCategoryId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfOrganizationsListByGroupPriceCategoryIdDto>> {
    return organizationsGetOrganizationsListByGroupPriceCategoryId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Organizations List By Group Price Category Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetOrganizationsListByGroupPriceCategoryId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetOrganizationsListByGroupPriceCategoryId(params?: OrganizationsGetOrganizationsListByGroupPriceCategoryId$Params, context?: HttpContext): Observable<CustomResultOfListOfOrganizationsListByGroupPriceCategoryIdDto> {
    return this.organizationsGetOrganizationsListByGroupPriceCategoryId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfOrganizationsListByGroupPriceCategoryIdDto>): CustomResultOfListOfOrganizationsListByGroupPriceCategoryIdDto => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateOrganizationGroupPriceCategory()` */
  static readonly OrganizationsUpdateOrganizationGroupPriceCategoryPath = '/Organizations/UpdateOrganizationGroupPriceCategory';

  /**
   * Update Organization Group Price Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateOrganizationGroupPriceCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateOrganizationGroupPriceCategory$Response(params: OrganizationsUpdateOrganizationGroupPriceCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationsUpdateOrganizationGroupPriceCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Organization Group Price Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateOrganizationGroupPriceCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateOrganizationGroupPriceCategory(params: OrganizationsUpdateOrganizationGroupPriceCategory$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationsUpdateOrganizationGroupPriceCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationsIsExistsOrganization()` */
  static readonly OrganizationsIsExistsOrganizationPath = '/Organizations/IsExistsOrganization';

  /**
   * Update Organization Group Price Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsIsExistsOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsIsExistsOrganization$Response(params: OrganizationsIsExistsOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfNullableBoolean>> {
    return organizationsIsExistsOrganization(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Organization Group Price Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsIsExistsOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsIsExistsOrganization(params: OrganizationsIsExistsOrganization$Params, context?: HttpContext): Observable<CustomResultOfNullableBoolean> {
    return this.organizationsIsExistsOrganization$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfNullableBoolean>): CustomResultOfNullableBoolean => r.body)
    );
  }

  /** Path part for operation `organizationsGetCurrentResellerOrganizationList()` */
  static readonly OrganizationsGetCurrentResellerOrganizationListPath = '/Organizations/GetCurrentResellerOrganizationList';

  /**
   * دریافت لیست سازمان های فروشنده فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetCurrentResellerOrganizationList()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetCurrentResellerOrganizationList$Response(params?: OrganizationsGetCurrentResellerOrganizationList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCurrentResellerOrganizationListDto>> {
    return organizationsGetCurrentResellerOrganizationList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست سازمان های فروشنده فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetCurrentResellerOrganizationList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetCurrentResellerOrganizationList(params?: OrganizationsGetCurrentResellerOrganizationList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCurrentResellerOrganizationListDto> {
    return this.organizationsGetCurrentResellerOrganizationList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCurrentResellerOrganizationListDto>): CustomResultOfListOfGetCurrentResellerOrganizationListDto => r.body)
    );
  }

  /** Path part for operation `organizationsGetCurrentOrganizationExpireDateForAdmin()` */
  static readonly OrganizationsGetCurrentOrganizationExpireDateForAdminPath = '/Organizations/GetCurrentOrganizationExpireDateForAdmin';

  /**
   * دریافت تاریخ انقضای سازمان جاری فقط برای ادمین سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetCurrentOrganizationExpireDateForAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetCurrentOrganizationExpireDateForAdmin$Response(params?: OrganizationsGetCurrentOrganizationExpireDateForAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfDateTime>> {
    return organizationsGetCurrentOrganizationExpireDateForAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تاریخ انقضای سازمان جاری فقط برای ادمین سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetCurrentOrganizationExpireDateForAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetCurrentOrganizationExpireDateForAdmin(params?: OrganizationsGetCurrentOrganizationExpireDateForAdmin$Params, context?: HttpContext): Observable<CustomResultOfDateTime> {
    return this.organizationsGetCurrentOrganizationExpireDateForAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfDateTime>): CustomResultOfDateTime => r.body)
    );
  }

}
